import { useCallback } from 'react'
import { useCreateApiNotification, useFetch } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'
import { Action } from 'civic-champs-shared/api/hooks/useRemoteCollection'
import { OrganizationLocationReporting } from 'locations/types'

export const useRemoveLocation = (remove: Action<OrganizationLocationReporting>, eager = true) => {
  const [request] = useFetch()
  const createNotification = useCreateApiNotification()
  const currentOrg = useCurrentOrg()

  return useCallback(
    async (location: OrganizationLocationReporting) => {
      let undo
      if (eager) {
        undo = remove(location)
      }
      const notification = createNotification('Removing locations')
      try {
        // @ts-ignore
        await request({
          method: 'del',
          url: `/organizations/${currentOrg.id}/locations/${location.id}`,
        })

        notification.onSuccess('Location removed!')
        if (!eager) {
          remove(location)
        }
      } catch (error) {
        notification.onError(`Could not remove ${location.name || 'selected'} location`, error)
        undo?.()
      }
    },
    [createNotification, currentOrg.id, remove, eager, request],
  )
}

export default useRemoveLocation
